import { render, staticRenderFns } from "./info-badge.vue?vue&type=template&id=1ff125d4&"
import script from "./info-badge.vue?vue&type=script&lang=ts&"
export * from "./info-badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff125d4')) {
      api.createRecord('1ff125d4', component.options)
    } else {
      api.reload('1ff125d4', component.options)
    }
    module.hot.accept("./info-badge.vue?vue&type=template&id=1ff125d4&", function () {
      api.rerender('1ff125d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/info-badge.vue"
export default component.exports